// extracted by mini-css-extract-plugin
export default {"container":"WelcomeLayout_container__FhKu6","layout":"WelcomeLayout_layout__hlEoK","header":"WelcomeLayout_header__QpG3U","content":"WelcomeLayout_content__l5g+m"};